export default __webpack_public_path__ + "static/media/camera-avatar.ad860744.svg";